import _ from "lodash";
import { useRef, useState } from "react";

const DEFAULT_OPTIONS = {
  offsetTop: 6,
  tooltipWidth: 288,
  hideDelay: 150,
};

const useTooltip = (options = {}) => {
  const { offsetTop, tooltipWidth, hideDelay } = _.defaults(
    options,
    DEFAULT_OPTIONS,
  );

  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPos, setTooltipPos] = useState(null);
  const hideTimer = useRef(null);

  const handleMouseEnter = e => {
    if (hideTimer.current) {
      clearTimeout(hideTimer.current);
      hideTimer.current = null;
    }
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltipPos({
      top: rect.bottom + offsetTop,
      left: Math.max(8, rect.left + rect.width / 2 - tooltipWidth / 2),
    });
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    hideTimer.current = setTimeout(() => {
      setShowTooltip(false);
      setTooltipPos(null);
    }, hideDelay);
  };

  return { showTooltip, tooltipPos, handleMouseEnter, handleMouseLeave };
};

export default useTooltip;
